/***************************************************************************************************

 Copyright 2023-2024 Fannie Mae. All rights reserved.
 This software contains confidential information and trade secrets of Fannie Mae.
 Use, disclosure, or reproduction is prohibited without the prior written consent of Fannie Mae.

 ****************************************************************************************************/

import {Injectable} from '@angular/core';
//import { Response } from '@angular/http';
import {HttpClient} from '@angular/common/http';


import {BehaviorSubject} from 'rxjs';

import {NotificationService} from './services/notification.service';


@Injectable()
export class APICallService {

  private message = new BehaviorSubject(null);

  constructor(public httpClient: HttpClient, public notificationService: NotificationService) {
  }

  res: Response;

}
